<template>
  <lb-drawer
    :value="visible"
    heading="Replace User"
    width="500"
    :loading="loading"
    data-testid="replace-team-member-drawer"
    @input="$emit('update:visible', $event)"
  >
    <template #body>
      <div data-testid="replace-team-member-drawer__body">
        <div class="mb-3" data-testid="replace-team-member-drawer__fromuser-row">
          <span class="font-weight-bold mr-2">From User:</span>
          <span class="noTransform" data-testid="replace-team-member-drawer__fromuser">
            {{ fromUserName }}
          </span>
        </div>
        <lb-dropdown
          label="To User*"
          :value="toUserId"
          :items="replaceUserList"
          itemtext="displayname"
          itemvalue="_id"
          item-class="noTransform"
          data-testid="replace-team-member-drawer__touser"
          @input="$emit('update:toUserId', $event)"
        />
        <div
          v-if="showTaskWarning"
          data-testid="replace-team-member-drawer__warning"
        >
          <div data-testid="replace-team-member-drawer__warning-text1">
            Since the user is also associated to various tasklist items, all those association will be replaced with the new user.
          </div>
          <div data-testid="replace-team-member-drawer__warning-text2">
            <span class="font-weight-bold mr-2">Note:</span>
            If the new user is already assigned to the tasklist item in a different capacity, then they will not be re-assigned.
          </div>
          <div class="font-weight-bold" data-testid="replace-team-member-drawer__warning-text3">
            Do you want to proceed?
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <span class="caption">*Required</span>
      <v-spacer />
      <v-btn
        color="primary"
        class="white--text"
        :disabled="!toUserId"
        data-testid="replace-team-member-drawer__replace-btn"
        @click="$emit('submit')"
      >
        <span data-testid="replace-team-member-drawer__replace-label">Replace</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'ReplaceTeamMemberDrawer',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    fromUserName: { type: String, default: 'Unknown' },
    toUserId: { type: String, default: '' },
    replaceUserList: { type: Array, default: () => [] },
    showTaskWarning: { type: Boolean, default: false }
  },
  emits: ['update:visible', 'update:toUserId', 'submit']
};
</script>
